// ── 콜 수정 모달 ─────────────────────────────────────────────────────────────
// - 상품·방문일자·미팅시간·상호·업종·주소·전화·휴대폰·대표자·마케터·내용 수정
// - 킵 등록/해제 (저장 시 반영)
// - 당일 등록 콜만 삭제 가능

import React from 'react';
import Modal from '../../../components/Modal';
import { PHONE_INPUT_MAX_LEN } from './constants';
import { toDateString } from '../../../utils/date';
import { sanitizePhoneInput } from './utils';
import {
  submitBtn, miniBtn, dangerMiniBtn, dangerMiniBtn_disabled,
  editFieldGrid, editFieldLabel, editFieldInput,
} from './formStyles';
import {
  editKeepBtnStyle, editKeepActiveBtnStyle,
} from './listChipStyles';

export function EditModal({
  editOpen, setEditOpen, editTarget, editForm, setEditForm,
  editSaving, deletingId, adminMode, isExtCategoryFixed, companyCode, isMovieAdminMode,
  ticketTypes, currentExternalCategoryName,
  salesPersonNames, editContentRef,
  onEditSave, onDelete, openKeepReleaseModal,
  showToast, todayKstStr,
}) {
  // 상품 필드 읽기 전용 조건: RegistrationForm과 동일 로직
  // is_category=false(개별 상품 선택 모드)이면 직원/관리자 모두 드롭다운 표시
  const isTicketTypeReadOnly =
    (!adminMode && !companyCode && isExtCategoryFixed) ||
    (Boolean(companyCode) && isExtCategoryFixed) ||
    isMovieAdminMode;

  return (
    <Modal
      open={editOpen}
      title="콜 수정"
      icon="✏️"
      onClose={() => setEditOpen(false)}
      footer={(
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
          {/* 삭제 버튼: 왼쪽 배치 — 당일 등록 콜만 삭제 가능 */}
          {(() => {
            const isToday = toDateString(editTarget?.call_date || '') === todayKstStr;
            return (
              <button
                style={isToday ? dangerMiniBtn : dangerMiniBtn_disabled}
                disabled={editSaving || deletingId === editTarget?.id || !isToday}
                title={isToday ? '' : '당일 등록한 콜만 삭제할 수 있습니다'}
                onClick={() => {
                  if (!isToday) { showToast('당일 등록한 콜만 삭제할 수 있습니다.', 'error'); return; }
                  setEditOpen(false);
                  onDelete(editTarget);
                }}
              >
                {deletingId === editTarget?.id ? '삭제중' : '삭제'}
              </button>
            );
          })()}
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={miniBtn} onClick={() => setEditOpen(false)}>취소</button>
            <button style={submitBtn} disabled={editSaving} onClick={onEditSave}>저장</button>
          </div>
        </div>
      )}
    >
      <div style={{ display: 'grid', gap: 8 }}>
        <div style={editFieldGrid}>
          <div style={editFieldLabel}>상품</div>
          {isTicketTypeReadOnly ? (
            <input style={{ ...editFieldInput, background: 'var(--bg-subtle)', color: 'var(--text-muted)' }}
              value={currentExternalCategoryName} readOnly />
          ) : (
            // value: ticket_types.id (정수), onChange: ticket_type_id에 숫자 저장
            <select style={{ ...editFieldInput, height: 34, boxSizing: 'border-box' }}
              value={editForm.ticket_type_id || ''}
              onChange={(e) => setEditForm({ ...editForm, ticket_type_id: Number(e.target.value) || null })}>
              <option value="">선택 안함</option>
              {ticketTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          )}
        </div>
        <div style={editFieldGrid}>
          <div style={editFieldLabel}>방문일자</div>
          <input style={editFieldInput} type="date" value={editForm.visit_date || ''}
            onChange={(e) => setEditForm({ ...editForm, visit_date: e.target.value })} />
        </div>
        <div style={editFieldGrid}>
          <div style={editFieldLabel}>미팅시간</div>
          <input style={editFieldInput} value={editForm.visit_time || ''}
            onChange={(e) => setEditForm({ ...editForm, visit_time: e.target.value })} />
        </div>
        <div style={editFieldGrid}>
          <div style={editFieldLabel}>상호</div>
          <input style={editFieldInput} value={editForm.company_name || ''}
            onChange={(e) => setEditForm({ ...editForm, company_name: e.target.value })} />
        </div>
        <div style={editFieldGrid}>
          <div style={editFieldLabel}>업종</div>
          <input style={editFieldInput} value={editForm.industry || ''}
            onChange={(e) => setEditForm({ ...editForm, industry: e.target.value })} />
        </div>
        <div style={editFieldGrid}>
          <div style={editFieldLabel}>주소</div>
          <input style={editFieldInput} value={editForm.address || ''}
            onChange={(e) => setEditForm({ ...editForm, address: e.target.value })} />
        </div>
        <div style={editFieldGrid}>
          <div style={editFieldLabel}>전화번호</div>
          <input style={editFieldInput} value={editForm.phone || ''} maxLength={PHONE_INPUT_MAX_LEN}
            inputMode="tel" pattern="[0-9-]*"
            onChange={(e) => setEditForm({ ...editForm, phone: sanitizePhoneInput(e.target.value) })} />
        </div>
        <div style={editFieldGrid}>
          <div style={editFieldLabel}>휴대폰</div>
          <input style={editFieldInput} value={editForm.mobile_phone || ''} maxLength={PHONE_INPUT_MAX_LEN}
            inputMode="tel" pattern="[0-9-]*"
            onChange={(e) => setEditForm({ ...editForm, mobile_phone: sanitizePhoneInput(e.target.value) })} />
        </div>
        <div style={editFieldGrid}>
          <div style={editFieldLabel}>대표자</div>
          <input style={editFieldInput} value={editForm.ceo_name || ''}
            onChange={(e) => setEditForm({ ...editForm, ceo_name: e.target.value })} />
        </div>
        <div style={editFieldGrid}>
          <div style={editFieldLabel}>마케팅담당자</div>
          <input style={editFieldInput} value={editForm.sales_person_name || ''}
            onChange={(e) => setEditForm({ ...editForm, sales_person_name: e.target.value })} />
        </div>
        <div style={{ ...editFieldGrid, alignItems: 'start' }}>
          <div style={{ ...editFieldLabel, paddingTop: 8 }}>내용</div>
          {/* 내용: 모달 열릴 때 + 타이핑 시 자동 높이 확장 (useEffect 처리) */}
          <textarea ref={editContentRef}
            style={{ ...editFieldInput, resize: 'none', overflow: 'hidden', lineHeight: 1.5 }}
            rows={3} value={editForm.content || ''}
            onChange={(e) => setEditForm({ ...editForm, content: e.target.value })} />
        </div>

        {/* 킵 등록/해제 — editForm.is_keep만 변경, 저장 시 반영 */}
        {!editTarget?.is_contracted && (
          <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, marginTop: 4 }}>
            {editForm?.is_keep ? (
              // 킵됨: 로컬 해제만 → 저장 시 반영 (결과 chip 클릭은 즉시 모달)
              <button type="button" style={editKeepActiveBtnStyle}
                onClick={() => setEditForm((prev) => prev ? { ...prev, is_keep: false } : prev)}>
                ★ 킵됨 — 해제하기
              </button>
            ) : (
              // 킵 미등록: 클릭 시 로컬 등록 → 저장 시 반영
              <button type="button" style={editKeepBtnStyle}
                onClick={() => setEditForm((prev) => prev ? { ...prev, is_keep: true } : prev)}>
                ☆ 킵 등록
              </button>
            )}
            {editForm?.is_keep && (
              <div style={{ ...editFieldGrid, alignItems: 'start', marginTop: 10 }}>
                <div style={{ ...editFieldLabel, paddingTop: 8 }}>킵 메모</div>
                <textarea
                  style={{ ...editFieldInput, resize: 'vertical', minHeight: 78, lineHeight: 1.5 }}
                  rows={3}
                  value={editForm.keep_memo || ''}
                  placeholder="킵으로 남긴 이유나 확인할 내용을 적어두세요."
                  onChange={(e) => setEditForm({ ...editForm, keep_memo: e.target.value })}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}
